(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-calculator')) {
    /**
     * Recommends a size from the customer's measurements.
     *
     * Config (JSON script inside the element):
     * - sizes: size names, smallest first
     * - garment: the garment in Norwegian, e.g. "kåpen" or "buksen"
     * - usualNote: shown when only the usual size is chosen
     * - measures: [{ name, label, min?, max: [largest body measurement per size] }]
     * - sizeUp (optional): true chooses the larger size when a measurement is on a boundary
     * - relaxedTip (optional): true suggests one size up for a more relaxed fit
     * - length (optional, used with a height field): { type: "coat" | "inseam", values: [garment length per size] }
     */
    const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');

    class SizeCalculator extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.result = this.querySelector('.size-calc__result');
        this.table = this.closest('.size-chart')?.querySelector('.size-chart__table');
        this.addEventListener('input', () => this.update());
        this.addEventListener('change', () => this.update());
      }

      number(name) {
        const value = parseFloat(String(this.querySelector(`[name="${name}"]`)?.value ?? '').replace(',', '.'));
        return Number.isFinite(value) && value > 0 ? value : null;
      }

      // Finds the smallest size that fits a body measurement. On a boundary the smaller size is chosen,
      // unless the config says to size up. Measurements above the largest size get an index past the end.
      sizeFor(value, measure) {
        if (measure.min && value < measure.min) return { index: 0, below: true };
        const index = measure.max.findIndex((max) => (this.config.sizeUp ? value < max : value <= max));
        return { index: index === -1 ? measure.max.length : index };
      }

      lengthNote(height, index) {
        const { length } = this.config;
        const value = length.values[index];
        const shown = isEnglish ? String(value) : String(value).replace('.', ',');

        if (length.type === 'inseam') {
          // Approximate floor-to-crotch height is about 47 % of body height
          const extra = Math.round(value - height * 0.47);
          if (extra >= 3) {
            return (isEnglish ? `The trousers have an inseam of ${shown} cm and will be about ${extra} cm longer than your legs. They fall over the foot and work well with heels, or can be taken up` : `Buksen har ${shown} cm innerbenslengde og blir ca. ${extra} cm lengre enn beina dine. Den går ned over foten, og passer fint med hæler eller kan legges opp`);
          }
          if (extra > -3) return (isEnglish ? `The trousers have an inseam of ${shown} cm and will reach about down to the floor on you` : `Buksen har ${shown} cm innerbenslengde og når omtrent ned til gulvet på deg`);
          return (isEnglish ? `The trousers have an inseam of ${shown} cm and will end about ${-extra} cm above the floor on you` : `Buksen har ${shown} cm innerbenslengde og slutter ca. ${-extra} cm over gulvet på deg`);
        }

        // Approximate shoulder height at the collar is about 84 % of body height
        const aboveFloor = Math.round(height * 0.84 - value);
        let where;
        if (aboveFloor <= 2) {
          where = (isEnglish ? 'will reach all the way down to the floor on you. It can easily be taken up by a tailor' : 'går helt ned til gulvet på deg. Den kan enkelt legges opp hos en skredder');
        } else if (aboveFloor <= 12) {
          where = (isEnglish ? `will end around your ankles, about ${aboveFloor} cm above the floor` : `slutter rundt anklene på deg, ca. ${aboveFloor} cm over gulvet`);
        } else {
          where = (isEnglish ? `will end at your lower calf, about ${aboveFloor} cm above the floor` : `slutter nederst på leggen på deg, ca. ${aboveFloor} cm over gulvet`);
        }
        return (isEnglish ? `The coat is ${shown} cm long and ${where}` : `Kåpen er ${shown} cm lang og ${where}`);
      }

      update() {
        const { sizes, garment, measures } = this.config;
        const largest = sizes.length - 1;
        let height = this.number('height');
        // Height written in metres, e.g. 1,68
        if (height && height < 3) height = Math.round(height * 100);
        const usualValue = this.querySelector('[name="usual"]').value;
        const usual = usualValue === '' ? null : Number(usualValue);
        const notes = [];
        let index = null;

        const found = measures
          .map((measure) => {
            const value = this.number(measure.name);
            return value ? { ...measure, ...this.sizeFor(value, measure) } : null;
          })
          .filter(Boolean);

        if (found.length) {
          index = Math.max(...found.map((measure) => measure.index));

          if (found.length > 1 && found.some((measure) => measure.index !== index)) {
            // "A, B og C"
            const list = (items) =>
              items.length > 1 ? (isEnglish ? `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}` : `${items.slice(0, -1).join(', ')} og ${items[items.length - 1]}`) : items[0];
            const [first, ...rest] = found;
            const parts = [
              (isEnglish ? `Your ${first.label.toLowerCase()} measurement fits size ${sizes[first.index]}` : `${first.label} ditt passer str. ${sizes[first.index]}`),
              ...rest.map((measure) => (isEnglish ? `your ${measure.label.toLowerCase()} measurement fits size ${sizes[measure.index]}` : `${measure.label.toLowerCase()} str. ${sizes[measure.index]}`)),
            ];
            const deciding = found
              .filter((measure) => measure.index === index)
              .map((measure, i) => (i === 0 ? measure.label : measure.label.toLowerCase()));
            notes.push((isEnglish ? `${list(parts)}. We go by the largest, so ${garment} won't feel tight.` : `${list(parts)}. ${list(deciding)} avgjør, så ${garment} ikke blir trang.`));
          }
          if (found.some((measure) => measure.below)) {
            notes.push((isEnglish ? `Your measurements are smaller than our smallest size, so ${garment} will fit loosely on you.` : `Målene dine er mindre enn den minste størrelsen, så ${garment} vil sitte romslig på deg.`));
          }
          if (usual !== null && usual !== index && index <= largest) {
            notes.push((isEnglish ? `You usually wear ${sizes[usual]}, but your measurements fit ${sizes[index]} best.` : `Du bruker vanligvis ${sizes[usual]}, men målene dine passer best med ${sizes[index]}.`));
          }
        } else if (usual !== null) {
          index = usual;
          notes.push(this.config.usualNote);
          notes.push((isEnglish ? 'Fill in your measurements for an even more accurate recommendation.' : 'Fyll inn målene dine for en enda sikrere anbefaling.'));
        }

        if (index !== null && index > largest) {
          this.highlight(null);
          this.result.hidden = false;
          this.result.innerHTML = `
            <p class="size-calc__answer">${isEnglish ? `Contact us and we will help you` : `Ta kontakt, så hjelper vi deg`}</p>
            <ul class="size-calc__notes">
              <li>${isEnglish ? `Your measurements are larger than our largest size, ${sizes[largest]}.` : `Målene dine er større enn vår største størrelse, ${sizes[largest]}.`}</li>
              <li>${isEnglish ? `Email us at <a href="mailto:shop@velinka.no">shop@velinka.no</a> and we will help you find out whether ${garment} could fit.` : `Send oss en e-post på <a href="mailto:shop@velinka.no">shop@velinka.no</a>, så hjelper vi deg med å finne ut om ${garment} kan passe.`}</li>
            </ul>
          `;
          return;
        }

        if (this.config.relaxedTip && index !== null && index < largest) {
          notes.push((isEnglish ? `For a looser fit, for example with a thick sweater underneath, we recommend size ${sizes[index + 1]}.` : `Vil du ha en løsere passform, for eksempel med en tykk genser under, anbefaler vi str. ${sizes[index + 1]}.`));
        }

        if (index !== null && height && height >= 140 && height <= 200) {
          notes.push((isEnglish ? `${this.lengthNote(height, index)}. This is an estimate based on typical body proportions.` : `${this.lengthNote(height, index)}. Dette er et anslag ut fra vanlige kroppsproporsjoner.`));
        } else if (height && (height < 140 || height > 200)) {
          notes.push((isEnglish ? 'Enter your height in centimetres, for example 168.' : 'Skriv inn høyden i centimeter, for eksempel 168.'));
        }

        this.highlight(index);

        if (index === null) {
          // Without a size, show the length for the middle size so the height still gives an answer
          const middle = Math.floor(largest / 2);
          const lengthText =
            this.config.length && height && height >= 140 && height <= 200
              ? `<ul class="size-calc__notes"><li>${this.lengthNote(height, middle)} ${isEnglish ? `(size ${sizes[middle]}). This is an estimate based on typical body proportions.` : `(str. ${sizes[middle]}). Dette er et anslag ut fra vanlige kroppsproporsjoner.`}</li></ul>`
              : '';
          this.result.hidden = !height;
          this.result.innerHTML = height
            ? `<p class="size-calc__intro">${isEnglish ? `Choose your usual size or fill in your measurements to get a recommendation.` : `Velg vanlig størrelse eller fyll inn målene dine for å få en anbefaling.`}</p>${lengthText}`
            : '';
          return;
        }

        this.result.hidden = false;
        this.result.innerHTML = `
          <p class="size-calc__answer">${isEnglish ? `We recommend size ${sizes[index]}` : `Vi anbefaler str. ${sizes[index]}`}</p>
          <ul class="size-calc__notes">${notes.map((note) => `<li>${note}</li>`).join('')}</ul>
        `;
      }

      // Marks the recommended size column in the table below
      highlight(index) {
        if (!this.table) return;
        this.table.querySelectorAll('.size-chart__active').forEach((cell) => cell.classList.remove('size-chart__active'));
        if (index === null) return;
        this.table.querySelectorAll('tr').forEach((row) => {
          if (row.classList.contains('size-chart__group')) return;
          row.children[index + 1]?.classList.add('size-chart__active');
        });
      }
    }

    customElements.define('size-calculator', SizeCalculator);

    // Opens and closes the size chart popup. Clicking outside the popup (on the backdrop) closes it.
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-size-chart-open]');
      if (opener) {
        opener.closest('.size-chart')?.querySelector('.size-chart__dialog')?.showModal();
        return;
      }
      if (event.target.closest('[data-size-chart-close]') || event.target.matches('.size-chart__dialog')) {
        event.target.closest('.size-chart__dialog')?.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
